import React, { useState, useEffect, createContext, useContext } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { CalendarPage } from "./components/calendar";
import { Contact } from "./components/contact";
import LoginPage from "./components/login";
import { AdminDashboard } from "./components/admin-dashboard";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase/firebase";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 2000,
  speedAsDuration: true,
});

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

const App = () => {
  const [landingPageData, setLandingPageData] = useState(JsonData);
  const location = useLocation();
  const { user, loading } = useAuth();

  if (!user) {
    console.log("User is logged out");
  } else {
    console.log("User is logged in:", user.email, location.pathname);
  }

  if (loading) return <p>Loading...</p>;

  if (
    user &&
    (location.pathname === "/gallery" ||
      location.pathname === "/booking" ||
      location.pathname === "/admin" ||
      location.pathname === "/")
  ) {
    return <AdminDashboard />;
  }

  return (
    <div>
      <Navigation isLogin={!!user} />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Header data={landingPageData.Header} />
              <Gallery data={landingPageData.Gallery} />
              <Services data={landingPageData.Services} />
              <CalendarPage />
              <Contact data={landingPageData.Contact} />
            </>
          }
        />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/admin/*"
          element={user ? <AdminDashboard /> : <Navigate to="/login" replace />}
        />
      </Routes>
    </div>
  );
};

export default App;
